import styled from 'styled-components';

export const StyledPropertyCard = styled.div``;
